import "@/index.css";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import SolutionDetail from "@/pages/SolutionDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Contact from "@/pages/Contact";
import RequestConsultation from "@/pages/RequestConsultation";
import MmpLanding from "@/pages/mmp/MmpLanding";
import MmpSubmit from "@/pages/mmp/MmpSubmit";
import MmpSuccess from "@/pages/mmp/MmpSuccess";
import MmpRetrieve from "@/pages/mmp/MmpRetrieve";
import MmpAdmin from "@/pages/mmp/MmpAdmin";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSolutions from "@/pages/admin/AdminSolutions";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminApplications from "@/pages/admin/AdminApplications";

const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/solutions", element: <Solutions /> },
      { path: "/solutions/:slug", element: <SolutionDetail /> },
      { path: "/projects", element: <Projects /> },
      { path: "/projects/:slug", element: <ProjectDetail /> },
      { path: "/contact", element: <Contact /> },
      { path: "/request-consultation", element: <RequestConsultation /> },
    ],
  },
  // MMP Portal — full-bleed dark theme, own layout (no PublicLayout)
  { path: "/careers", element: <MmpLanding /> },
  { path: "/careers/submit", element: <MmpSubmit /> },
  { path: "/careers/success/:uniqueId", element: <MmpSuccess /> },
  { path: "/careers/retrieve", element: <MmpRetrieve /> },
  // Secret admin route — URL is the credential
  { path: "/admin-marine-secure-2026", element: <MmpAdmin /> },
  { path: "/admin/login", element: <AdminLogin /> },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "solutions", element: <AdminSolutions /> },
      { path: "projects", element: <AdminProjects /> },
      { path: "blog", element: <AdminBlog /> },
      { path: "leads", element: <AdminLeads /> },
      { path: "applications", element: <AdminApplications /> },
      { path: "newsletter", element: <AdminNewsletter /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);

export default function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
